module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/fr-card-drag.ff794c8c55fb35dbf3c0.gif";